import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { BarCodeCategory, KeyValueId, KeyValueSetInt, LastUsedKey, LastUsedSettingsType, LocalService, NumericConfig } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-print-qrcode',
  templateUrl: './print-qrcode.component.html',
  styleUrl: './print-qrcode.component.scss'
})
export class PrintQrcodeComponent {
  @ViewChild('content_print_qrcode')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() barcodeValue: string = '';
  @Input() value: string = '';
  @Input() categoryCode: number = BarCodeCategory.None;
  @Input() businessId: string = '';
  barCodeSize: number = 0; paperWidth: number = 0; paperHeight: number = 0;
  fontSizeTop: number = 0; fontSizeBottom: number = 0; colorCode: string = '';
  title = '';

  printContent: string = ''; IsPrint: boolean = false; FileName = 'QrCode';

  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  elementIds: any; htmlId: string = '';

  labelsTop: KeyValueId[] = []; labelsBottom: KeyValueId[] = [];

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private profileManagementService: ProfileManagementService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      qr_code_container: 'print-qrcode_container-' + this.htmlId,
      qr_code_print: 'btn-print-qrcode' + this.htmlId
    };

    const englishLanguageId = this.localService.getLanguageId('en');
    this.labelsTop = [{ key: englishLanguageId, value: '' } as KeyValueId, { key: englishLanguageId, value: '' } as KeyValueId];
    this.labelsBottom = [{ key: englishLanguageId, value: 'Order your items from here' } as KeyValueId, { key: englishLanguageId, value: '' } as KeyValueId];
  }

  ngOnInit(): void {
    setTimeout(() => { //To avoid NG0100 error
      this.onLoad();
    }, 0);
  }

  onLoad() {
    if (this.businessId) {
      const bizName = this.localService.getBusinessName(this.businessId);
      this.labelsTop[0].key = this.localService.getLanguageId(bizName.key);
      this.labelsTop[0].value = bizName.value;
    }
  }

  ngOnChanges(): void {
    setTimeout(() => { //To avoid NG0100 error
      if (this.isOpenPopup) {
        this.onInitiate();
        this.offcanvasService.open(this.content, {
          position: 'end',
          backdrop: 'static',
          keyboard: false,
          animation: true,
          panelClass: 'popup_overlay_right',
          beforeDismiss: this.onBeforeDismiss
        });
      }
    }, 0);
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onInitiate() {
    this.title = BarCodeCategory[this.categoryCode].toString();
    this.onFillMandatory();
    if (!this.barcodeValue) {
      this.barcodeValue = this.value;
    }
  }

  onSaveLastUsedSettings() {
    if (!this.barCodeSize)
      this.barCodeSize = 200;

    let items: LastUsedKey[] = [];
    let temp = this.localService.getLastUsedSetting(LastUsedSettingsType.QrPrintSize, this.onGetBusinessId());
    if (temp != this.barCodeSize.toString())
      items.push({ keyType: LastUsedSettingsType.QrPrintSize, value: this.barCodeSize.toString() } as LastUsedKey);

    if (items.length > 0) {
      if (this.onGetBusinessId()) {
        this.profileManagementService.saveLastUsedSettings(items, this.onGetBusinessId()).subscribe(result => {
        });
      } else {
        this.profileManagementService.saveLastUsedSettings(items).subscribe(result => {
        });
      }
    }
  }

  onGetBusinessId(): string | undefined {
    let businessId: string | undefined = undefined;
    if (this.businessId && this.businessId != '0')
      businessId = this.businessId;
    else if (this.categoryCode == BarCodeCategory.Business)
      businessId = this.value;
    return businessId;
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onFillMandatory();
        if (!this.localService.defaultStyles) {
          this.configurationManagementService.getGlobalConfigurationByCode('receipt_style', this.businessId).subscribe(result => {
            this.localService.defaultStyles = this.localService.replaceAll(result.value, '{{font_path}}', environment.url.app + 'assets/scss/');
            this.onPrint();
          });
        } else {
          this.onPrint();
        }
      } break;
    }
  }

  onPrint() {
    let canvas = document.getElementById(this.elementIds.qr_code_container).getElementsByTagName('canvas')[0] as HTMLCanvasElement;

    this.printContent = '<style>' + this.localService.defaultStyles + '</style>';
    this.printContent += '<div style="height:' + this.paperHeight + 'px;width:' + this.paperWidth + 'px">';

    this.labelsTop.filter(x => x.value.toString().trim()).forEach(item => {
      this.printContent += '<div style="text-align:center;margin-bottom:20px;color:#' + this.colorCode + '"><span style="font-size:' + this.fontSizeTop + 'px;" class="' + this.localService.getLanguageCode(item.key) + '">' + item.value + '</span></div>';
    });

    this.printContent += '<div style="text-align:center"><img style="width:"' + this.barCodeSize + '"px;height:"' + this.barCodeSize + '"px; src="' + canvas.toDataURL() + '"/></div>';

    this.labelsBottom.filter(x => x.value.toString().trim()).forEach(item => {
      this.printContent += '<div style="text-align:center;margin-top:20px;color:#' + this.colorCode + '"><span style="font-size:' + this.fontSizeBottom + 'px;" class="' + this.localService.getLanguageCode(item.key) + '">' + item.value + '</span></div>';
    });

    this.printContent += '</div>';
    this.IsPrint = true;
  }

  onPrintedBarcode() {
    this.printContent = '';
    this.IsPrint = false;
  }

  onFillMandatory() {
    if (!this.barCodeSize)
      this.barCodeSize = 1000;
    if (!this.paperWidth)
      this.paperWidth = 1080;
    if (!this.paperHeight)
      this.paperHeight = 1200;
    if (!this.fontSizeTop)
      this.fontSizeTop = 50;
    if (!this.fontSizeBottom)
      this.fontSizeBottom = 40;
    if (!this.colorCode || this.colorCode.length != 6)
      this.colorCode = '0E5390';
  }
}
